import { match } from 'ts-pattern';

type HeadingTag = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

/**
 * Calculates the appropriate HTML heading tag and className for a given depth.
 */
export const getHeadingPropsForDepth = (
  depth: number,
): { tag: HeadingTag; className: string } => {
  const tag: HeadingTag = match(depth)
    .with(1, () => 'h1' as const)
    .with(2, () => 'h2' as const)
    .with(3, () => 'h3' as const)
    .with(4, () => 'h4' as const)
    .with(5, () => 'h5' as const)
    .otherwise(() => 'h6' as const);

  const sizeClasses = match(depth)
    .with(1, () => 'text-md @md:text-2xl')
    .with(2, () => 'text-sm @md:text-xl')
    .otherwise(() => 'text-xs @md:text-lg');

  const className = `font-semibold text-text-primary ${sizeClasses}`;

  return { tag, className };
};
